export default {
  schedule: {
    date_and_time: 'Dato og tidspunkt*',
    number_of_guests: 'Antal gæster*',
    location: 'Sted:',
  },
  personal_information: {
    title: 'Titel',
    first_name: 'Fornavn',
    enter_first_name: 'Indtast fornavn',
    last_name: 'Efternavn*',
    enter_last_name: 'Indtast efternavn',
    email: 'E-mail',
    enter_email: 'Indtast e-mail',
    phone: 'Telefon',
    annotation: 'Bemærkning',
    enter_annotation: 'Indtast bemærkning',
  },
  gender: {
    without_title: 'Uden titel',
    male: 'Hr.',
    female: 'Fru',
  },
  buttons: {
    save: 'Gem',
  },
  error_messages: {
    invalid_email: 'Indtast venligst en gyldig e-mailadresse uden mellemrum eller umlauter før @.',
    invalid_phone_number: 'Ugyldigt telefonnummer. Kontrollér dine oplysninger, og prøv igen.',
    failed_reservation: 'Din reservation kunne ikke sendes. Kontrollér dine oplysninger, og prøv igen.',
    invalid_reservation_day: 'Vi tager ikke imod reservationer på denne dag.',
    no_tables_available: 'Beklager, vi har ikke flere ledige borde.',
    please_enter_guests: 'Angiv antal gæster.',
    please_select_time: 'Vælg et tidspunkt.',
    please_select_last_name: 'Angiv efternavn',
  },
  success_messages: {
    reservation_saved: 'Reservationen blev gemt',
  },
};
